import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../../utils/toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { RiCloseCircleFill } from "react-icons/ri";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import EditDocumentForm from "./EditDocumentForm";
import ButtonUI from "../../material-ui/ButtonUI";
import editDocument from "../../../api/editDocument";
import { AuthContext } from "../../../context/Auth/AuthContext";
import { EditActionButton } from "../../common/ActionIconButton";
import EditIcon from "@mui/icons-material/Edit";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <RiCloseCircleFill />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const editDocumentFormSchema = yup.object().shape({
  documentTitle: yup.string().required("Document Title is required field"),
  // documentDescription: yup
  //   .string()
  //   .required("Document Description is required field"),
  subcategory: yup.string().required("Sub Category is required field"),
});

/*** Component for editing the mailroom documents ***/
const EditDocumentPopup = ({
  tableValues,
  subCategoryOption,
  setDocumentUpdatedToTrue,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token, userID } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editDocumentFormSchema),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onEditDocumentFormSubmit = async (editDocumentFormData) => {
    setLoading(true);
    const editDocumentFormResponse = await editDocument({
      token: token,
      user_id: userID,
      case_number: "",
      document_id: tableValues.documentID,
      document_name: editDocumentFormData.documentTitle,
      document_desc: editDocumentFormData.documentDescription,
      document_sub_category: editDocumentFormData.subcategory,
    });

    if (editDocumentFormResponse.code === 200) {
      setDocumentUpdatedToTrue();
      setOpen(false);
      setLoading(false);
      showSuccess("Document is updated successfully");
    } else {
      setLoading(false);
      showError("Error while updating document");
    }
  };

  return (
    <div className="dialog-modal">
      <EditActionButton onClick={handleClickOpen} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        className="custom-edit-modal"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="edit-doc-modal"
          onClose={handleClose}
        >
          <div className="popup-header-svg-icon">
            <EditIcon />
          </div>
          <div className="popup-header-title">Edit Document</div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <EditDocumentForm
            register={register}
            control={control}
            errors={errors}
            tableValues={tableValues}
            subCategoryOption={subCategoryOption}
            setDocumentUpdatedToTrue={setDocumentUpdatedToTrue}
          />
        </DialogContent>
        <DialogActions sx={{ paddingBottom: "15px !important" }}>
          <div className="popup_submit_btn">
            <ButtonUI
              loading={loading}
              variant="contained"
              buttonText="Submit"
              style={{
                backgroundColor: "#1a6b7c",
                boxShadow: "none",
                border: "1px solid #1a6b7c",
                fontWeight: "500",
                borderRadius: "4px",
                letterSpacing: "0.07rem",
                marginTop: "20px",
              }}
              handleSubmit={handleSubmit}
              onFormSubmit={onEditDocumentFormSubmit}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default EditDocumentPopup;
